import { Box } from '@mui/material';

type Props = {
  children?: React.ReactNode;
};

export default function SidebarSection(props: Props): JSX.Element {
  return (
    <Box sx={{ 
        textAlign: "left",
        position: "relative",
        padding: "5px 20px"
      }}>
      <h3>{props.children}</h3>
    </Box>
  );
}